<template>
    <div ref="accountModal" class="modal fade" :id="dialogId" role="dialog" :aria-labelledby="dialogId"
         aria-hidden="true">
        <div class="modal-dialog modal-dialog-popout" role="document">
            <div class="modal-content">
                <div class="block block-themed block-transparent mb-0">
                    <div class="block-header bg-primary-dark">
                        <h3 class="block-title">{{title}}</h3>
                        <div class="block-options">
                            <button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close">
                                <i class="fa fa-fw fa-times"/>
                            </button>
                        </div>
                    </div>
                    <div class="block-content">
                        <form>
                            <div class="form-group">
                                <label>Account Name</label>
                                <input :class="{'is-invalid': errors.name}" v-model="account.name" type="text"
                                       class="form-control">
                                <div v-if="errors.name" :class="['invalid-feedback']">
                                    {{errors.name[0]}}
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Account Type</label>
                                <select :class="{'is-invalid': errors.type}" v-model="account.type"
                                        class="form-control">
                                    <option v-for="(acType, index) in accountTypes" :key="index" :value="acType.key">
                                        {{acType.title}}
                                    </option>
                                </select>
                                <div v-if="errors.type" :class="['invalid-feedback']">
                                    {{errors.type[0]}}
                                </div>
                            </div>
                            <div class="form-group" v-if="account.type === 'credit'">
                                <label>Account Currency</label>
                                <select :class="{'is-invalid': errors.currency}" v-model="account.currency"
                                        class="form-control">
                                    <option :value="currency.code" v-for="(currency, key) in currencies"
                                            :key="key">{{currency.name}} ({{currency.symbol}})
                                    </option>
                                </select>
                                <div v-if="errors.currency" :class="['invalid-feedback']">
                                    {{errors.currency[0]}}
                                </div>
                            </div>
                            <div class="form-group" v-show="account.type === 'payments'">
                                <label for="account-number">Account Number</label>
                                <input type="number" id="account-number" :class="{'is-invalid': errors.accountNumber}"
                                       v-model="account.accountNumber" rows="3" class="form-control">
                                <div v-if="errors.accountNumber" :class="['invalid-feedback']">
                                    {{errors.accountNumber[0]}}
                                </div>
                            </div>
                        </form>
                    </div>
                    <slot name="submit"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import currencies from '../../../../currencies';

    export default {
        props: {
            dialogId: String,
            title: String,
            account: Object
        },
        name: "AccountForm",
        data() {
            return {
                currencies: [{
                    "symbol": "Ksh",
                    "name": "Kenyan Shilling",
                    "symbol_native": "Ksh",
                    "decimal_digits": 2,
                    "rounding": 0,
                    "code": "KES",
                    "name_plural": "Kenyan shillings"
                }],
                accountTypes: [
                    {
                        key: 'unit',
                        title: 'SMS Units Account',
                    },
                    {
                        key: 'credit',
                        title: 'Resource and Deductions Account',
                    }
                ]
            }
        },
        mounted() {
            $(this.$refs.accountModal).on('hidden.bs.modal', () => {

            });
        },
        computed: {
            ...mapGetters({
                errors: 'getAccountsErrors',
            })
        },
        methods: {}
    }
</script>
